import { Badge } from 'components/ds'
import { SessionEmailThread } from '../services/dispatchHelpApi'
import { EmailStatusBadge } from './EmailStatusBadge'

function initials(name: string | null, email: string | null): string {
    const src = name || email || '?'
    const parts = src.split(/\s+/).filter(Boolean)
    if (parts.length === 0) return '?' // all-whitespace input — avoid indexing an empty array
    if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase()
    return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase()
}

function route(t: SessionEmailThread): string {
    const o = [t.originCity, t.originState].filter(Boolean).join(', ')
    const d = [t.destinationCity, t.destinationState].filter(Boolean).join(', ')
    return o && d ? `${o} → ${d}` : o || d || ''
}

export function EmailThreadRow({ thread, onSelect }: { thread: SessionEmailThread; onSelect: (t: SessionEmailThread) => void }) {
    const unread = thread.unreadCount > 0
    return (
        <button
            type="button"
            onClick={() => onSelect(thread)}
            className="flex w-full items-start gap-3 border-b border-slate-100 px-4 py-3 text-left transition-colors hover:bg-slate-50 dark:border-slate-700/60 dark:hover:bg-slate-800/60"
        >
            <div className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-slate-100 text-xs font-semibold text-slate-600 dark:bg-slate-700 dark:text-slate-200">
                {initials(thread.brokerName, thread.brokerEmail)}
            </div>
            <div className="min-w-0 flex-1">
                <div className="flex items-center justify-between gap-2">
                    <span
                        className={`truncate text-sm ${unread ? 'font-semibold text-slate-900 dark:text-slate-100' : 'font-medium text-slate-700 dark:text-slate-200'}`}
                    >
                        {thread.brokerName || thread.brokerEmail || 'Unknown broker'}
                    </span>
                    {unread && (
                        <Badge variant="primary" size="sm" className="shrink-0">
                            {thread.unreadCount}
                        </Badge>
                    )}
                </div>
                <div className={`mt-0.5 truncate text-xs ${unread ? 'text-slate-600 dark:text-slate-300' : 'text-slate-400 dark:text-slate-500'}`}>
                    {thread.statusReason || route(thread) || 'No preview'}
                </div>
                <div className="mt-1.5">
                    <EmailStatusBadge status={thread.status} reason={thread.statusReason} />
                </div>
            </div>
        </button>
    )
}
